import React from 'react';
import { cn } from '../../utils/cn';
import { getStatusVariant, getStatusLabel, STATUS_VARIANT_CLASSES } from '../../utils/statusColors';

interface StatusChipProps {
  status: string | null | undefined;
  size?: 'xs' | 'sm';
  className?: string;
}

/**
 * Uniform status chip used across positions, schedule, and orders surfaces.
 * Colour is derived via `getStatusVariant` so the same status value always
 * renders the same colour, no matter which screen the trader is on.
 *
 * Display label uses `getStatusLabel` for statuses with friendly names
 * (e.g. PENDING_PLACE → "Placing…"). Falls back to the raw enum string.
 */
export const StatusChip: React.FC<StatusChipProps> = ({ status, size = 'sm', className }) => {
  if (!status) return null;
  const variant = getStatusVariant(status);
  const label = getStatusLabel(status) ?? status;
  return (
    <span
      className={cn(
        'inline-flex items-center rounded font-bold uppercase tracking-wider whitespace-nowrap',
        size === 'xs' ? 'px-1.5 py-0.5 text-[9px]' : 'px-2 py-0.5 text-[10px]',
        STATUS_VARIANT_CLASSES[variant],
        className,
      )}
    >
      {label}
    </span>
  );
};

export default StatusChip;
